import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <GoogleOAuthProvider clientId='323591092272-f8macg4bpp372kcg22ubimn6b5mlv4oo.apps.googleusercontent.com'>
    <App />
  </GoogleOAuthProvider>
);